
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.188 3h5.625l.156.813.594 2.969a9.951 9.951 0 012.594 1.531l2.906-1 .781-.25.406.719 2 3.438.406.719-.594.531-2.25 1.969c.084.513.188 1.022.188 1.563s-.104 1.05-.188 1.563l2.25 1.969.594.531-.406.719-2 3.438-.406.719-.781-.25-2.906-1a9.935 9.935 0 01-2.594 1.531l-.594 2.969-.156.813h-5.625l-.156-.813-.594-2.969a9.951 9.951 0 01-2.594-1.531l-2.906 1-.781.25-.406-.719-2-3.438-.406-.719.594-.531 2.25-1.969c-.084-.513-.188-1.022-.188-1.563s.104-1.05.188-1.563l-2.25-1.969-.594-.531.406-.719 2-3.438.406-.719.781.25 2.906 1a9.935 9.935 0 012.594-1.531l.594-2.969zm1.625 2l-.5 2.594-.125.594-.563.188a7.964 7.964 0 00-3.031 1.75l-.438.406-.563-.188-2.531-.875L5.874 11.5l2 1.781.469.375-.156.594c-.128.57-.188 1.153-.188 1.75s.06 1.18.188 1.75l.156.594-.469.375-2 1.781 1.188 2.031 2.531-.875.563-.188.438.406a7.979 7.979 0 003.031 1.75l.563.188.125.594.5 2.594h2.375l.5-2.594.125-.594.563-.188a7.964 7.964 0 003.031-1.75l.438-.406.563.188 2.531.875 1.188-2.031-2-1.781-.438-.375.125-.594c.128-.572.188-1.153.188-1.75s-.06-1.18-.188-1.75l-.156-.594.469-.375 2-1.781-1.188-2.031-2.531.875-.563.188-.438-.406a7.979 7.979 0 00-3.031-1.75l-.563-.188-.125-.594-.5-2.594h-2.375zM16 11c2.75 0 5 2.25 5 5s-2.25 5-5 5-5-2.25-5-5 2.25-5 5-5zm0 2c-1.669 0-3 1.331-3 3s1.331 3 3 3 3-1.331 3-3-1.331-3-3-3z"}})])
          )
        }
      }
    